import { createTermTagManager } from '../../utils/createTermTagManager';

export const elevatorsMinCountTagManager = createTermTagManager({
  jsonQueryKey: 'lifts',
  label: 'Есть лифт',
  id: 'elevatorsMinCount',
});
